<script>
import TemplateComponent from './component.vue';

export default {
  props: {
    module: Object,
  },
  components: {
    TemplateComponent,
  },
  methods: {
    setStyles() {
      const el = document.querySelector('#mag-main');
      const { styles } = this.$refs.main;
      if (el && styles) {
        el.style.paddingTop = styles.paddingTop;
        el.style.paddingRight = styles.paddingRight;
        el.style.paddingBottom = styles.paddingBottom;
        el.style.paddingLeft = styles.paddingLeft;
      }
    },
  },
  created() {
  },
  mounted() {
    this.$watch('$refs.main.styles', () => {
      this.setStyles();
    });
    this.setStyles();
  },
};
</script>
<template>
  <TemplateComponent
    :module="module"
  >
    <v-main ref="main" style="display: none;">
      <slot></slot>
    </v-main>
  </TemplateComponent>
</template>
<style lang="scss">
  body .v-application--wrap {
    min-height: 0;
  }

  body .v-application {
    z-index: 1000;
    position: relative;
  }

  .mag-main {
    max-width: 100%;
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    min-height: 100vh;
  }

  .mag-main {
    padding: 64px 0 0 256px;
  }

  .v-badge__badge.red {
    color: #fff !important;
  }

  .v-list {
    a {
      text-decoration: none !important;
    }
  }


  .v-input {
    textarea {
      border: none;
      transition: none;
      box-shadow: none;
      border-radius: 0;
      height: auto;
    }
  }
</style>
